import { render, staticRenderFns } from "./StudentEdit.vue?vue&type=template&id=2a7e7b07&scoped=true"
import script from "./StudentEdit.vue?vue&type=script&lang=js"
export * from "./StudentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e7b07",
  null
  
)

export default component.exports